import { render, staticRenderFns } from "./FeaturedProducts.vue?vue&type=template&id=d699ebd8&"
import script from "./FeaturedProducts.vue?vue&type=script&lang=js&"
export * from "./FeaturedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports